import styled from "styled-components";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import { UtilsApi } from "../../../client/tenants/utils.api";
import { constants } from "../../common/constants/constants";
import { useSelector } from "react-redux";
import ServerData from "../../common/serverData";

export const NotFoundStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  h1 {
    font-variant: small-caps;
  }
`;
export function ProductsAtDiscount() {
    const client = new ServerData();
    const {t} = useTranslation();
    const userProfile = useSelector(state => state.auth.userProfile);

    const sendEmailNotification = async () => {
        const name = userProfile.userFirstName;
        const id = userProfile.userID;
        const params = {
            sendTo: ["ohad@bllink.co", "rayee@bllink.co"],
            title: `subject: Products at a Discount page visited by ${name}`,
            content: 'User visited Products at a discount page <br>' +
                `Name: ${name} <br>` +
                `ID: ${id} <br>`,
        };
        const utilsApi = new UtilsApi(client);
        return await utilsApi.postInternalEmail(constants.backendEndpoints.GENERIC_INTERNAL_EMAIL_ENDPOINT, '', params);
    }


    useEffect(async () => {
        if (userProfile?.userID) {
            await sendEmailNotification();
        }
    }, [userProfile]);

    return (
        <NotFoundStyled>
            <h1 className="bllink-heading1">{t('buildings.nav_bar_products_at_a_discount')}</h1>
            <div className="bllink-text">{t('titles.coming_soon')}</div>
        </NotFoundStyled>
    )
}


